import React from 'react';
import { Link } from 'react-scroll';
import { FaExternalLinkAlt } from 'react-icons/fa';

function Products() {
  return (
    <div className="containery products-section" id="products">
      <h2 className="main-title text-center products-heading">OUR PRODUCTS</h2>
      <p className="text-center products-intro">
        Two lines of business we own end to end: loans and real estate. The same people who write
        the code also keep the systems running.
      </p>
      <div className="products-grid">
        <article className="product-card">
          <h3 className="product-card-title">Renstia Loans</h3>
          <p className="product-card-text">
            Loans for people and for businesses. We keep terms clear, paperwork sensible, and the
            process as simple as we can. Ask us about business credit, salary-backed loans, or other
            facilities we offer.
          </p>
          <Link
            className="product-card-cta"
            to="contact"
            spy
            smooth
            duration={800}
            href="#contact"
          >
            Talk to us about a loan
          </Link>
        </article>
        <article className="product-card product-card-featured">
          <h3 className="product-card-title">Renstia Real Estate</h3>
          <p className="product-card-text">
            Tools and listings for anyone looking for a place to rent or buy. We built and run{' '}
            <strong>rentalsug.com</strong> for Uganda—search, listings, and the day-to-day flows
            landlords and tenants need.
          </p>
          <a
            className="product-card-cta product-card-cta-external"
            href="https://rentalsug.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Open rentalsug.com
            <FaExternalLinkAlt className="product-card-cta-icon" aria-hidden />
          </a>
        </article>
      </div>
    </div>
  );
}

export default Products;
